import React, { useState } from 'react';
import DonutChartContainer from '../../component/Graph/DonutChart';
import { pulseSurveyPageData } from '../../utils/pageContent';

const AssessmentResultQuestion = ({ questionsList, index }) => {
  const [showChart, setShowChart] = useState(false);
  const color = [
    '#4A57DA',
    '#20BDAD',
    '#F05289',
    '#0D2535',
    '#FF6F61',
    '#6A1B9A',
    '#FFB74D',
    '#4CAF50',
    '#00BCD4',
    '#FFC107'
  ];
  let isChart = 0;
  const pageData = pulseSurveyPageData.resultPageData;

  let data = [];
  if (questionsList?.options?.length > 0) {
    data = questionsList.options.map((element) => {
      isChart += element.count;
      return {
        lable: element.value,
        value: element.count
      };
    });
  }

  return (
    <div
      key={index}
      className="px-3 py-6 sm:px-6 sm:py-8 border-[1.5px] mt-[10px] border-shoorah-borderGray bg-white rounded-2xl dark:bg-shoorah-darkBgTabColor dark:border-none"
    >
      <div className="flex justify-center items-center mb-4 sm:mb-[30px] border-b pb-4 sm:pb-6 border-[#CED2D5] sm:flex-row flex-col">
        <div className="flex w-full items-center z-0">
          <div className="h-fit rounded-lg px-4 py-1 sm:px-6 sm:py-3 mr-3 sm:mr-[1.5%] text-shoorah-lightBlack bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray">
            {pageData.questionSign}
            {index + 1}
          </div>
          <h2 className="sm:leading-normal tracking-none sm:tracking-normal h-fit w-full md:w-full lg:max-w-[46%] leading-9 text-lg sm:text-[24px] font-medium mb-5 sm:mb-0 flex items-center">
            {questionsList.title}
          </h2>
        </div>
        <div className="whitespace-nowrap font-medium leading-9 text-shoorah-textBlack">
          {questionsList.totalResponses ? questionsList.totalResponses : 0}{' '}
          {pageData.respondentText}
        </div>
      </div>
      {questionsList?.options?.length > 0 && (
        <div className="w-full flex flex-col items-end">
          <div className="flex flex-col space-y-7 mb-12 w-full sm:w-[calc(100%-91px)] justify-center">
            {questionsList.options.map((option, optIndex) => (
              <label
                className="flex items-center justify-between sm:flex-row flex-col"
                key={optIndex}
              >
                <div className="flex items-center w-full sm:w-auto gap-4">
                  <input type="radio" className="w-6 h-6" disabled />
                  <p className="font-medium">{option.value}</p>
                </div>
                <div className="flex items-center gap-2 sm:gap-6 font-medium">
                  <div className="w-[90px] sm:w-[156px] flex justify-end">
                    <div
                      className={`h-[15px]`}
                      style={{
                        width: `${option.percentage}`,
                        backgroundColor: `${color[optIndex]}`
                      }}
                    ></div>
                  </div>
                  |<div className="font-medium">{option.percentage}</div>|<div>{option.count}</div>
                </div>
              </label>
            ))}
          </div>
        </div>
      )}

      {data?.length > 0 && (
        <>
          {showChart && (
            <>
              {isChart !== 0 ? (
                <div className="w-full flex items-center justify-center">
                  <DonutChartContainer color={color} data={data} />
                </div>
              ) : (
                <div className="text-center text-[20px] w-[99%] tracking-tight flex items-start justify-center font-medium text-[#0B0F18] pl-[0px] md:pl-[0px] dark:text-shoorah-darkBg">
                  {pageData.noChartDataText}
                </div>
              )}
            </>
          )}
          <div className="w-full flex justify-end">
            {showChart ? (
              <button
                className="rounded-3xl py-2 sm:py-3 md:px-10 px-6 text-sm font-medium text-white shadow-sm border border-transparent bg-shoorah-active"
                onClick={() => setShowChart(false)}
              >
                {pageData.hideChartBtnText}
              </button>
            ) : (
              <button
                className="rounded-3xl py-2 sm:py-3 md:px-10 px-6 text-sm font-medium text-white shadow-sm border border-transparent bg-shoorah-active"
                onClick={() => setShowChart(true)}
              >
                {pageData.showChartBtnText}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default AssessmentResultQuestion;
